import { useEffect, useRef } from 'react';
import { onLCP, onINP, onCLS, type CLSMetric, type LCPMetric, type INPMetric } from 'web-vitals';

interface WebVitalsEvent {
    event: 'pageview';
    event_name: 'page_load_performance';
    page: {
        page_vital_name: 'LCP' | 'INP' | 'CLS';
        page_vital_value: number;
        page_vital_status: 'good' | 'needs-improvement' | 'poor';
    };
}

/**
 * Composant qui envoie les métriques Web Vitals à Google Tag Manager
 * - LCP (Largest Contentful Paint)
 * - INP (Interaction to Next Paint) — remplace FID, retiré de web-vitals 4
 * - CLS (Cumulative Layout Shift)
 */
export function WebVitals() {
    // Protection contre React Strict Mode (double mount)
    const initialized = useRef(false);

    useEffect(() => {
        if (initialized.current) return;
        initialized.current = true;

        onCLS(webVitalsEvent);
        onINP(webVitalsEvent);
        onLCP(webVitalsEvent);
    }, []);

    function webVitalsEvent({ name, value, rating }: LCPMetric | INPMetric | CLSMetric) {
        const event: WebVitalsEvent = {
            event: 'pageview',
            event_name: 'page_load_performance',
            page: {
                page_vital_name: name,
                page_vital_value: value,
                page_vital_status: rating,
            },
        };

        window.dataLayer.push(event as unknown as Record<string, unknown>);
    }

    return null;
}
